import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import moment from "moment";

// UI Components
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-regular-svg-icons";

const PERMISSION_OPTIONS = [
  { label: "Read Only", value: 1 },
  { label: "User", value: 2 },
  { label: "Admin", value: 3 },
  { label: "Super Admin", value: 4 },
];

export default ({ admin_user, onUserAction }) => [
  {
    dataField: "firstname_vch",
    text: "Name",
    sort: true,
    isDummyField: true,
    formatter: (cell, user) => `${user.firstname_vch} ${user.lastname_vch}`,
  },
  {
    dataField: "email_vch",
    text: "Email",
    sort: true,
  },
  {
    dataField: "group_id_bint",
    text: "Permissions",
    isDummyField: true,
    sort: true,
    formatter: (cell, user) => (
      <Select
        value={PERMISSION_OPTIONS.find((option) => option.value === user.group_id_bint)}
        options={PERMISSION_OPTIONS.filter((option) => option.value <= admin_user.group_id_bint)}
        onChange={(selected) => onUserAction("update", user, selected.value)}
      />
    ),
  },
  {
    dataField: "created_dt",
    text: "Created",
    sort: true,
    formatter: (created_dt) => moment(created_dt).format("lll"),
  },
  {
    dataField: "action",
    text: "Actions",
    isDummyField: true,
    headerStyle: () => ({ width: "100px" }),
    formatter: (cell, user) => (
      <Fragment>
        <Link to="#" onClick={() => onUserAction("delete", user)}>
          <FontAwesomeIcon icon={faTrashAlt} size="lg" color="red" />
        </Link>
      </Fragment>
    ),
  },
];
